import { Checkbox } from "@mui/material";
import { CheckboxIcon } from "@shared/frontend/icons";
import type { CellContext } from "@tanstack/react-table";
import React from "react";

interface SelectRowCellProps<Entity> extends CellContext<Entity, unknown> {
  checked: boolean;
  onChange: (value: boolean) => void;
}

const SelectRowCell = <Entity extends any>(
  props: SelectRowCellProps<Entity>,
) => {
  const { checked, onChange } = props;

  return (
    <Checkbox
      disableTouchRipple
      icon={<CheckboxIcon />}
      checkedIcon={<CheckboxIcon checked />}
      checked={checked}
      onChange={(_, v) => onChange(!!v)}
      aria-label="Select row"
    />
  );
};

export default SelectRowCell;
